import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

export const getLeadType = async (params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        API_ENDPOINTS.Lead.GET_LEAD_TYPES,
        { params: params }
    );
    console.log(
        "🚀 ~ file: LeadRepository.ts ~ line 10 ~ getLeadType ~ response",
        response
    );
    return response?.data;
};
export const addLeadTypes = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Lead.ADD_LEAD_TYPE, body);
};
export const updateLeadType = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Lead.UPDATE_LEAD_TYPE}/${id}`, body);
};

export const getLeadFields = async (LeadTypeId: number | any, params?: Record<string, any>) => {
    const response = await axiosInstance.get(
        `${API_ENDPOINTS.Lead.GET_LEAD_FIELDS}/${LeadTypeId}`,
        { params: params }
    );
    console.log(
        "🚀 ~ file: SubscriberRepository.ts ~ line 9 ~ getSubscriberFields ~ response",
        response
    );
    return response?.data;
};
export const addLeadFields = async (body: any) => {
    return axiosInstance.post(API_ENDPOINTS.Lead.ADD_LEAD_FIELD, body);
};
export const updateLeadFields = async (id: number, body: any) => {
    return axiosInstance.put(`${API_ENDPOINTS.Lead.UPDATE_LEAD_FIELD}/${id}`, body);
};